import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { ApplicationPipesModule } from 'app/main/applicationPipesModule.module';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { FormsModule } from '@angular/forms';

import { AspRequestWishlistComponent } from './asp-request-wishlist.component';
import { AspRequestExistspopupComponent } from '../asp-request-existspopup/asp-request-existspopup.component';
import { AspRequestSuccessPopupComponent } from '../asp-request-success-popup/asp-request-success-popup.component';

const routes: Routes = [
  {
    path: 'request-wishlist',
    component: AspRequestWishlistComponent,
  },
];

@NgModule({
  declarations: [
    AspRequestWishlistComponent, AspRequestExistspopupComponent, AspRequestSuccessPopupComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    FuseSharedModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    ApplicationPipesModule,
    MatBottomSheetModule,
  ],
  exports: [AspRequestWishlistComponent],
})

export class AspRequestWishlistModule { }